// extracted by mini-css-extract-plugin
export default {"warning":"warning-qH1Ku","fontSizeDropdown":"fontSizeDropdown-eqEFU","copiesCount":"copiesCount-yYv8m","counter":"counter-YTj1l"};